

import { ConnectionPositionPair, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { Injectable, NgZone } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import { MwcContextMenuServiceModule } from './context-menu.service.module';
import { MwcDropdownMenuComponent } from './dropdown-menu.component';

const listOfPositions = [
  new ConnectionPositionPair({ originX: 'start', originY: 'top' }, { overlayX: 'start', overlayY: 'top' }),
  new ConnectionPositionPair({ originX: 'start', originY: 'top' }, { overlayX: 'start', overlayY: 'bottom' }),
  new ConnectionPositionPair({ originX: 'start', originY: 'top' }, { overlayX: 'end', overlayY: 'bottom' }),
  new ConnectionPositionPair({ originX: 'start', originY: 'top' }, { overlayX: 'end', overlayY: 'top' })
];

@Injectable({
  providedIn: MwcContextMenuServiceModule
})
export class MwcContextMenuService {
  private overlayRef: OverlayRef | null = null;
  private closeSubscription = Subscription.EMPTY;

  constructor(private ngZone: NgZone, private overlay: Overlay) {}

  create($event: MouseEvent | { x: number; y: number }, mwcDropdownMenuComponent: MwcDropdownMenuComponent): void {
    this.close(true);
    const { x, y } = $event;
    if ($event instanceof MouseEvent) {
      $event.preventDefault();
    }
    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo({ x, y })
      .withPositions(listOfPositions)
      .withTransformOriginOn('.mwc-dropdown');
    this.overlayRef = this.overlay.create({
      positionStrategy,
      disposeOnNavigation: true,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });

    this.closeSubscription = new Subscription();

    this.closeSubscription.add(mwcDropdownMenuComponent.descendantMenuItemClick$.subscribe(() => this.close()));

    this.closeSubscription.add(
      this.ngZone.runOutsideAngular(() =>
        fromEvent<MouseEvent>(document, 'click')
          .pipe(
            filter(event => !!this.overlayRef && !this.overlayRef.overlayElement.contains(event.target as HTMLElement)),
            /** handle firefox contextmenu event **/
            filter(event => event.button !== 2),
            take(1)
          )
          .subscribe(() => this.ngZone.run(() => this.close()))
      )
    );

    this.overlayRef.attach(
      new TemplatePortal(mwcDropdownMenuComponent.templateRef, mwcDropdownMenuComponent.viewContainerRef)
    );
  }

  close(clear: boolean = false): void {
    if (this.overlayRef) {
      this.overlayRef.detach();
      if (clear) {
        this.overlayRef.dispose();
      }
      this.overlayRef = null;
      this.closeSubscription.unsubscribe();
    }
  }
}
